import React from 'react';
const CART_URL = 'https://tiendaonlineint.myshopify.com/checkouts/cn/hWN8cnomcuMjuuHhkkFi94K3/es-ar?_r=AQABF7-_rqMchD8pQ6vqe_Bg7XiHEiLZKe65tF4ZfYKAnis&preview_theme_id=186920173903';
interface CtaButtonProps {
  children: React.ReactNode;
  subtitle?: string;
  className?: string;
  size?: 'default' | 'large';
}
export function CtaButton({
  children,
  subtitle,
  className = '',
  size = 'default'
}: CtaButtonProps) {
  const sizeClasses = size === 'large' ? 'text-xl md:text-2xl px-10 md:px-14 py-5 md:py-6' : 'text-lg md:text-xl px-8 md:px-12 py-4 md:py-5';
  return <a href={CART_URL} className={`
        inline-block
        bg-gradient-to-b from-green to-green-dark
        text-white
        font-sans font-extrabold
        uppercase tracking-wide
        rounded-lg
        shadow-[0_4px_14px_rgba(76,175,80,0.4)]
        hover:shadow-[0_6px_20px_rgba(76,175,80,0.5)]
        hover:-translate-y-0.5
        transition-all duration-200
        text-center
        ${sizeClasses}
        ${className}
      `} data-id="element-55">
      {children}
      {subtitle && <span className="block text-sm font-normal opacity-90 mt-1 normal-case" data-id="element-56">
          {subtitle}
        </span>}
    </a>;
}